import { createContext, useContext, useEffect, useState, useRef } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { InterviewAdvanceSearchService } from "../../../services/InterviewAdvanceSearch";
import { InterviewService } from "../../../services/InterviewService";

import { FieldNames } from "./FieldNames";
import { CommonService } from "../../../services/CommonService";
import { scheduleSearchService } from "../../../services/ScheduleSearchService";

const advanceSearchContext = createContext();
export default function AdvanceSearchContextProviderTest({ children }) {
  const [personalSkills, setpersonalSkills] = useState([]);

  const [searchObject, setSearchObject] = useState({
    skills: [],
    zones: [],
    jobRoles: [],
    managerInterestId: [],
    yearsOfExperienceOptions: [],
    seniorityLevels: [],
    pageNumber: 1,
    selectedFilters: [],
    languageLevels: [],
    orderBy: "ModifiedDate",
    order: 1,
    tags: []
  });
  const [activeTab, setActiveTab] = useState("search");

  const [pageSize, setPageSize] = useState(10);
  const PAGE_ONE = 1;
  const [pageNumber, setPageNumber] = useState(1);
  const [interviews, setInterviews] = useState([]);
  const [totalpages, setTotalPages] = useState(0);

  const { t } = useTranslation();
  const [errors, setErrors] = useState([]);
  const [searches, setSearches] = useState([]);
  const [cardStatus, setCardStatus] = useState({
    competence: true,
    global: false,
    condition: false,
    personal: false,
    work: false,
    education: false,
    applicationDetails: false
  });
  const [buttonStatus, setButtonStatus] = useState({
    competence: true,
    global: false,
    condition: false,
    personal: false,
    work: false,
    education: false,
    applicationDetails: false
  });

  const [storedSearch, setStoredSearch] = useState(null);
  function changebuttonStatus(buttonName) {
    setButtonStatus({
      ...buttonStatus,
      [buttonName]: !buttonStatus[buttonName]
    });
  }

  function changeCardStatus(cardName) {
    setCardStatus({
      competence: false,
      global: false,
      condition: false,
      personal: false,
      work: false,
      education: false,
      applicationDetails: false,
      [cardName]: !cardStatus[cardName]
    });
  }

  const validateErrors = () => {
    const _errors = {};
    if (searchObject.languageId && searchObject.languageLevels.length === 0) {
      _errors.languageLevels = t("At least one level must be selected");
    }
    if (!searchObject.languageId && searchObject.languageLevels.length >= 1) {
      _errors.languageId = t("You must choose a language.");
    }
    setErrors(_errors);
    return Object.keys(_errors).length > 0;
  };

  useEffect(
    () => CommonService.getAllSkills().then((data) => setpersonalSkills(data)),
    []
  );

  function initiatePersonalSkills() {
    if (personalSkills && personalSkills.length > 0) {
      let _personnalSkills = personalSkills.map((skill) => {
        return {
          description: skill.description,
          id: skill.id,
          rating: 0
        };
      });
      return _personnalSkills;
    }
  }

  function onChange({ target }) {
    if (target.value)
      setSearchObject({
        ...searchObject,
        [target.name]: target.value
      });
    else {
      setSearchObject({
        ...searchObject,
        [target.name]: undefined
      });
    }
  }

  function onRemoveSelected(filterName) {
    let _searchObject = { ...searchObject };
    switch (filterName) {
      case FieldNames.betweenDates:
        _searchObject["endingDate"] = undefined;
        _searchObject["startingDate"] = undefined;
        break;
      case FieldNames.skills:
        _searchObject["skills"] = [];
        break;
      case FieldNames.businessArea:
        _searchObject["businessArea"] = [];
        break;
      case FieldNames.techArea:
        _searchObject["techArea"] = [];
        break;
      case FieldNames.techRole:
        _searchObject["techRole"] = [];
        break;
      case FieldNames.candidateInterestBusinessArea:
        _searchObject["candidateInterestBusinessArea"] = [];
        break;
      case FieldNames.candidateInterestTechArea:
        _searchObject["candidateInterestTechArea"] = [];
        break;
      case FieldNames.candidateInterestTechRole:
        _searchObject["candidateInterestTechRole"] = [];
        break;
      case FieldNames.jobRoleId:
        _searchObject["jobRoles"] = [];
        break;
      case FieldNames.zoneId:
        _searchObject["zones"] = [];
        break;
      case FieldNames.professionalExperienceYearsId:
        _searchObject["yearsOfExperienceOptions"] = [];
        break;
      case FieldNames.tags:
        _searchObject["tags"] = [];
        break;
      case FieldNames.managerInterestId:
        _searchObject["managerInterestId"] = [];
        break;
      case FieldNames.seniorityLevelsId:
        _searchObject["seniorityLevel"] = [];
        break;
      case FieldNames.languageLevelId:
        _searchObject["languageLevels"] = [];
        break;
      case FieldNames.competences:
        _searchObject.personalSkills = initiatePersonalSkills();
        break;
      case FieldNames.CurrentSalary:
        _searchObject["lowerBoundCurrentSalary"] = undefined;
        _searchObject["upperBoundCurrentSalary"] = undefined;
        break;
      case FieldNames.expectedSalary:
        _searchObject["lowerBoundSalary"] = undefined;
        _searchObject["upperBoundSalary"] = undefined;
        break;
      case FieldNames.availability:
        _searchObject["availability"] = undefined;
        _searchObject["noticeId"] = undefined;
        break;
      case FieldNames.birthDate:
        _searchObject["birthDateEnd"] = undefined;
        _searchObject["birthDateStart"] = undefined;
        break;
      case FieldNames.coursebyDate:
        _searchObject["courseStartDate"] = undefined;
        _searchObject["courseEndDate"] = undefined;
        break;
      case FieldNames.languageId:
        _searchObject["languageId"] = undefined;
        _searchObject["languageLevelId"] = undefined;
        break;
      case FieldNames.currentSalaryValueIsLiquid:
        _searchObject["currentSalaryValueIsLiquid"] = undefined;
        break;
      case FieldNames.salaryExpectedValueIsLiquid:
        _searchObject["salaryExpectedValueIsLiquid"] = undefined;
        break;
      default:
        _searchObject[filterName] = undefined;
        break;
    }
    setSearchObject(_searchObject);
  }

  function clear() {
    let _searchObject = {
      skills: [],
      orderby: "ModifiedDate",
      managerInterestId: [],
      order: 1,
      zones: [],
      yearsOfExperienceOptions: [],
      languageLevels: [],
      seniorityLevels: [],
      jobRoles: [],
      businessAreas: [],
      candidateBusinessAreas: [],
      tags: []
    };
    setErrors({});
    _searchObject.personalSkills = initiatePersonalSkills();
    setSearchObject(_searchObject);
  }
  function executeScheduleSearch(_searchObject) {
    search(_searchObject);
  }
  function executeSearch() {
    if (validateErrors()) {
      return;
    }
    if (pageNumber === PAGE_ONE) search(searchObject);
    else setPageNumber(PAGE_ONE);
  }
  function saveSearch(name) {
    if (validateErrors()) {
      return;
    }
    let formated = formatRequest(searchObject);
    formated.name = name;
    formated.json = JSON.stringify(searchObject);
    formated.scheduleId = storedSearch?.id;
    InterviewAdvanceSearchService.saveSearch(formated).then((data) => {
      toast.success(t("Search saved successfully"));

      scheduleSearchService.getMySearches().then((data) => {
        setSearches(data);
        setActiveTab("mySearches");
      });
    });
  }

  function formatRequest(_searchObject) {
    let formated = { ..._searchObject };

    if (formated.personalSkills)
      formated.personalSkills = formated.personalSkills.filter(
        (skill) => skill.rating > 0
      );
    formated.skills = formated.skills.map((skill) => skill.id);
    formated.zones = formated.zones.map((zone) => zone.id);
    formated.managerInterestId = formated.managerInterestId.map(
      (managerInterest) => managerInterest.id
    );
    formated.jobRoles = formated.jobRoles.map((jobRole) => jobRole.id);
    formated.yearsOfExperienceOptions = formated.yearsOfExperienceOptions.map(
      (yearsOfExperience) => yearsOfExperience.id
    );
    formated.tags = formated.tags.map((tags) => tags.id);
    formated.seniorityLevels = formated.seniorityLevels.map(
      (seniorityLevels) => seniorityLevels.id
    );
    formated.languageLevels = formated.languageLevels.map(
      (languageLevel) => languageLevel.id
    );
    if (formated.businessAreas?.length > 0)
      formated.businessAreas = formated.businessAreas.map(
        (businessArea) => businessArea.id
      );
    if (formated.candidateBusinessAreas?.length > 0)
      formated.candidateBusinessAreas = formated.candidateBusinessAreas.map(
        (candidateBusinessArea) => candidateBusinessArea.id
      );
    return formated;
  }

  function sort(_searchObject) {
    setInterviews([]);
    setSearchObject(_searchObject);
    search(_searchObject);
  }

  function search(_searchObject) {
    _searchObject = formatRequest(_searchObject);
    callSearchService(_searchObject);
  }
  function callSearchService(_searchObject) {
    InterviewService.advanceSearch(_searchObject, pageSize, pageNumber).then(
      (data) => {
        setInterviews(data.page);
        setTotalPages(Math.ceil(data.total / pageSize));
        setActiveTab("searchResults");
        if (data.total === 0) toast.warning(t("No results found."));
      }
    );
  }

  const firstLoad = useRef(true);
  useEffect(() => {
    if (firstLoad.current) firstLoad.current = false;
    else {
      search(searchObject);
    }
  }, [pageNumber, pageSize]);

  return (
    <advanceSearchContext.Provider
      value={{
        searchObject,
        setSearchObject,
        onChange,

        t,

        initiatePersonalSkills,
        onRemoveSelected,
        clear,
        activeTab,
        setActiveTab,
        totalpages,
        setPageNumber,
        pageNumber,
        interviews,
        sort,

        executeSearch,
        setPageSize,

        errors,
        saveSearch,
        executeScheduleSearch,
        setSearches,
        searches,
        cardStatus,
        buttonStatus,
        changebuttonStatus,
        changeCardStatus,
        setButtonStatus,
        storedSearch,
        setStoredSearch,
        setInterviews,
        setTotalPages
      }}
    >
      {children}
    </advanceSearchContext.Provider>
  );
}
export function useAdvanceSearchContext() {
  const context = useContext(advanceSearchContext);
  return context;
}
